export type OutsideSort = 'distance' | 'az';

export function parseOutsideSort(value: string | null | undefined): OutsideSort {
  return value === 'az' || value === 'alphabetical' ? 'az' : 'distance';
}

type SortablePlace = {
  name: string;
  distance_km?: number | null;
};

function distanceOrLast(km: number | null | undefined): number {
  return km == null || !Number.isFinite(km) ? Number.POSITIVE_INFINITY : km;
}

export function sortOutsidePlaces<T extends SortablePlace>(places: readonly T[], sort: OutsideSort): T[] {
  const list = [...places];
  if (sort === 'az') {
    list.sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }));
    return list;
  }
  list.sort((a, b) => distanceOrLast(a.distance_km) - distanceOrLast(b.distance_km));
  return list;
}
